import classNames from "classnames"
import { animationClass } from "features/data-management/workspace/constants"

export const FolderSVG = ({
    fillColor,
    borderColor,
}: {
    fillColor: string
    borderColor: string
}) => {
    return (
        <svg
            className={classNames("w-full h-full", animationClass)}
            viewBox="0 0 247 118"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth={2}
            preserveAspectRatio="none"
        >
            <mask id="inner-stroke-mask">
                <path
                    d="M8 0C3.58172 0 0 3.58172 0 8V19H0.0618938C0.0210433 19.3276 0 19.6613 0 20V110C0 114.418 3.58173 118 8.00001 118H239C243.418 118 247 114.418 247 110V20C247 15.5817 243.418 12 239 12H93.4222L84.7895 4.95523C80.8623 1.75039 75.9489 0 70.88 0H8Z"
                    fill="white"
                />
                <path
                    d="M8 2C4.68629 2 2 4.68629 2 8V20V110C2 113.313 4.68629 116 8 116H239C242.314 116 245 113.313 245 110V20C245 16.6863 242.314 14 239 14H93.4222L84.7895 6.95523C81.7573 4.4953 78.0403 2 70.88 2H8Z"
                    fill="black"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C3.58172 0 0 3.58172 0 8V19H0.0618938C0.0210433 19.3276 0 19.6613 0 20V110C0 114.418 3.58173 118 8.00001 118H239C243.418 118 247 114.418 247 110V20C247 15.5817 243.418 12 239 12H93.4222L84.7895 4.95523C80.8623 1.75039 75.9489 0 70.88 0H8Z"
                fill={fillColor}
            />
            <path
                d="M8 0C3.58172 0 0 3.58172 0 8V19H0.0618938C0.0210433 19.3276 0 19.6613 0 20V110C0 114.418 3.58173 118 8.00001 118H239C243.418 118 247 114.418 247 110V20C247 15.5817 243.418 12 239 12H93.4222L84.7895 4.95523C80.8623 1.75039 75.9489 0 70.88 0H8Z"
                fill="none"
                stroke={borderColor}
                strokeWidth="2"
                mask="url(#inner-stroke-mask)"
            />
        </svg>
    )
}
